import { ReactNode, useState } from "react";
import { Box, InputBase, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { onChangeEvent } from "../../../../../../../../utils/types/generals";
import { reportFolioServices } from "../../../main/constants/states";

type onChange = (
  e: onChangeEvent,
  child?: ReactNode | number | { blur: boolean }
) => void;

export type CommentFormProps = {
  id?: string;
  submitted: (response: any) => void;
  cancel: () => void;
  hasComments: boolean;
};

export const CommentForm = ({
  id,
  submitted,
  cancel,
  hasComments,
}: CommentFormProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const [comment, setComment] = useState("");

  const crudChange: onChange = ({ target }) => {
    setComment(target.value);
  };

  const emitForm = async () => {
    setLoading(true);
    const body = { comment };
    const idFolio = parseInt(id || "");
    const response = await reportFolioServices.saveComment({
      id: idFolio,
      body,
    });
    setLoading(false);
    submitted(response);
    setComment('')
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        overflow: "hidden",
        backgroundColor: "#fff",
        borderRadius:'8px'
      }}
    >
      {/* Input estilizado */}
      <InputBase
        placeholder="Comentario..."
        value={comment}
        onChange={crudChange}
        sx={{
          flex: 1,
          padding: "0px 14px",
          fontSize: "14px",
          color: "#333",
        }}
        inputProps={{
          maxLength: 65535,
        }}
      />

      {/* Botón de enviar */}
      <LoadingButton
        loading={loading}
        variant="contained"
        onClick={emitForm}
        disabled={!comment}
        sx={{
          borderRadius: "0px",
          borderTopRightRadius: "8px",
          borderEndEndRadius: "8px",
          backgroundColor: "#1976D2",
          padding: "10px 20px",
          "&:hover": {
            backgroundColor: "#1565C0",
          },
        }}
      >
        Enviar ➤
      </LoadingButton>
    </Box>
  );
};
